import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {Employee} from "../models/employee";
import {UserData} from "../models/user-data";
import {Disponibilita} from "../models/disponibilita";
import {Toolbar} from "../models/toolbar";
import {map} from "rxjs/operators";
import { PnFunzioneServizio } from '../models/servizio';
import { HomePageHeaderFooter } from '../models/home-page-header-footer.model';

@Injectable({
  providedIn: 'root'
})
export class AmministrazioneService {
  public results: any;
  url = "services/portaleamministrazione/api";
  urlNextApp = "services/nextappointment/api";

  constructor(private httpClient: HttpClient) {
  }

  getIdByNmServizio(servizio: string):Observable<string>{
    return this.httpClient.get(this.url + "/getIdService?nmServizio=" + servizio, { responseType: 'text' });
  }

  querySearch(search: string): Observable<Toolbar[]> {
    return this.httpClient.get<Toolbar[]>(this.url + "/search?s=" + search + "&appl=PNRR");
  }

  ricercaCittadinoAPI(userData: UserData | null): Observable<any> {
    return this.httpClient.get<UserData[] | null>(this.url + "/pn-utente/search?s=" + encodeURIComponent(JSON.stringify(userData)))
  }

  ricercaCittadinoByCFAPI(cf: string): Observable<UserData> {
    return this.httpClient.get<UserData>(this.url + "/pn-utente/by-cf/" + cf);
  }

  inserimentoUtenteAPI(userData: UserData): Observable<any> {
    return this.httpClient.post<any>(this.url + "/pn-utente/insert", userData)
  }

  ricercaDipendenteAPI(form: any): Observable<any> {
    return this.httpClient.get<any>(this.url + "/pn-dipendente/search?s=" + encodeURIComponent(JSON.stringify(form)))
  }

  datiDipendentePerListaID(idDipendente: string[]): Observable<Employee[]> {
    return this.httpClient.get<Employee[]>(this.url + "/pn-dipendente/getDati?s=" + idDipendente);
  }

  aggiungiDipendenteAPI(form: any): Observable<any> {
    return this.httpClient.get<any>(this.url + "/pn-dipendente/insert?s=" + encodeURIComponent(JSON.stringify(form)));
  }

  datiUfficioAPI(form: any): Observable<any> {
    return this.httpClient.get<any>(this.urlNextApp + "/na-ufficio/search?s=" + encodeURIComponent(JSON.stringify(form)));
  }

  datiSedeAPI(form: any): Observable<any> {
    return this.httpClient.get<any>(this.urlNextApp + "/na-sede/search?s=" + encodeURIComponent(JSON.stringify(form)));
  }

  ricercaDisponibilita(idDipendente: any): Observable<Disponibilita []> {
    return this.httpClient.get<Disponibilita []>("services/nextappointment/api/search-dipendendente/" + idDipendente);
  }

  pnFunzioneServizioByCdFunzione(cdFunzione: string):Observable<PnFunzioneServizio>{
    return this.httpClient.get<PnFunzioneServizio>(`${this.url}/pn-funzione-servizioByCdFunzione?cdFunzione=${cdFunzione}`)
  }
}
